<template>
  <div id="app">
    <!-- first commit -->
    <div class="language" style="z-index: 1000000; text-align: right; position: fixed; right: 15px; top: 15px;">
      <mu-container>
        <mu-select v-model="locale" style="width: 110px;">
          <mu-option label="中文" value="zh"></mu-option>
          <mu-option label="English" value="en"></mu-option>
        </mu-select>
      </mu-container>
    </div>
    <div style="height: 50px;"></div>
    <router-view/>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'app',
  data() {
    return {
      locale: (this.$i18n.locale === 'en') ? 'en' : 'zh',
      videoId: 'wWB37NiBlao',
    }
  },
  computed: {
  },
  mounted() {
    const localLang = localStorage.getItem('lang');
    if (localLang === 'en' || this.$route.query.lang === 'en') {
      this.$i18n.locale = 'en';
      this.locale = 'en';
    } else {
      this.$i18n.locale = 'zh';
    }
  },
  watch: {
    locale(val) {
      this.$i18n.locale = val;
    },
  },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.bottomNav {
  z-index: 100000;
}
.mu-dialog-body {
  position: relative !important;
}
.el-input-group__prepend {
  width: 120px;
  padding: 4px 10px;
  color: black;
  border: 1px solid;
  border-right: none;
}
.el-textarea__inner {
  border: 1px solid;
}
.el-table__expanded-cell[class*=cell] {
  padding: 10px 20px !important;
}
.el-form-item__label {
  padding: 0 !important;
}
.el-form-item {
  margin-bottom: 5px !important;
}
.el-button {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.el-input__inner {
  border: 1px solid black;
}
.el-input.is-disabled .el-input__inner {
  border: 1px solid black;
}
.el-button--info.is-plain {
  color: #666;
  border: 1px solid #666;
}
.el-button--success.is-plain {
  border: 1px solid #67c23a;
}
.el-button--danger.is-plain {
  border: 1px solid #f56c6c;
}
.el-input.is-disabled .el-input__inner {
  color: #666 !important;
  font-weight: 500;
  font-size: 15px;
}
.el-radio__input.is-checked+.el-radio__label {
  color: #666;
}
.el-radio__input.is-checked .el-radio__inner {
  border-color: #666;
  background: #666;
}
.mu-step-label {
  padding-left: 11px !important;
  padding-right: 10px !important;
}
.mu-step-label-icon-container {
  margin-right: 3px !important;
}
.mu-input {
  margin-bottom: 8px !important;
}
 #__vconsole .vc-switch {
  bottom: 70px !important;
}
</style>
